import { render } from "./SlideItemButton.vue?vue&type=template&id=161bd03c&scoped=true&ts=true"
import script from "./SlideItemButton.vue?vue&type=script&lang=ts"
export * from "./SlideItemButton.vue?vue&type=script&lang=ts"

import "./SlideItemButton.vue?vue&type=style&index=0&id=161bd03c&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161bd03c"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
